import { CheckIfLoggedIn } from '../components';

export function Home() {
  return (
    <CheckIfLoggedIn>
      <div>Home</div>
    </CheckIfLoggedIn>
  );
}
